import { useEffect, useState } from 'react';
import styled from 'styled-components';

import { KeyInfoList } from 'components/Toolkit/KeyInfoList/KeyInfoList';

export type OpeningHourProps = {
  day: string;
  openTime?: string;
  closeTime?: string;
  appointmentOnly?: boolean;
  appointmentOnlyText?: string;
  isToday: boolean;
  isOpen?: boolean;
};

export interface OpeningHoursProps {
  openingHours?: OpeningHourProps[];
  className?: string;
}

const OpeningHoursContainer = styled.div`
  background-color: ${({ theme }) => theme.colors.OFFWHITE};
  padding: ${({ theme }) => `${theme.spacing.S8} ${theme.spacing.M16}`};
`;

function OpeningHours({ openingHours, className }: OpeningHoursProps) {
  const [mapOpeningHours, setMapOpeningHours] = useState<
    { displayName: string; value: string; status?: 'ACTIVE' | 'CLOSED' }[]
  >([]);

  useEffect(() => {
    let mappedOpeningHours: {
      displayName: string;
      value: string;
      status?: 'ACTIVE' | 'CLOSED';
    }[] = [];
    openingHours &&
      openingHours.forEach((item) => {
        mappedOpeningHours.push({
          displayName: item.day,
          value: getOpeningHourValue(item),
          status: item.isToday
            ? item.isOpen !== undefined
              ? item.isOpen
                ? 'ACTIVE'
                : 'CLOSED'
              : undefined
            : undefined,
        });
      });
    setMapOpeningHours(mappedOpeningHours);
    // TODO Clean up this effect's dependencies. We're disabling this lint error for now so we can
    // clean up the lint logs. Ideally we should rewrite this code to be less error prone and trust
    // the lint rule's judgement.
    // https://distilledsch.tpondemand.com/RestUI/Board.aspx#page=userstory/98606
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function getOpeningHourValue({
    openTime,
    closeTime,
    appointmentOnly,
    appointmentOnlyText,
  }: OpeningHourProps): string {
    if (appointmentOnlyText && appointmentOnlyText !== '') {
      return appointmentOnlyText;
    } else if (appointmentOnly) {
      return 'By appointment only';
    } else if (!Boolean(openTime) && !Boolean(closeTime)) {
      return 'CLOSED';
    } else {
      return `${openTime} to ${closeTime}`;
    }
  }

  return (
    <OpeningHoursContainer className={className}>
      <KeyInfoList
        singleColumnOnDesktop={true}
        infoList={mapOpeningHours}
        variant="SMALL"
      />
    </OpeningHoursContainer>
  );
}

export { OpeningHours };
